import { render } from "./History.vue?vue&type=template&id=33cf6eb2&scoped=true"
import script from "./History.vue?vue&type=script&lang=js"
export * from "./History.vue?vue&type=script&lang=js"

import "./style.less?vue&type=style&index=0&id=33cf6eb2&scoped=true&lang=css&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33cf6eb2"]])

export default __exports__